import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  ...args
}) => {
  return (
    <Button
      className={`ttnc-ButtonPrimary hover:bg-slate-500 hover:text-white disabled:bg-opacity-90 shadow-xl ${className}`}
      {...args}
    />
  );
};

export default ButtonPrimary;
